<template lang="pug">
.report-item
  .component-title 共检索到
    span {{ total }}
    | 份报告
  .lists(style="width: 100%; height: 100%")
    ReportViewsList(:lists="list")
    .loading
      a(v-show="!loading && pages.now < pages.sum", @click.prevent="more") 查看更多
      loader(v-show="loading")
</template>

<script>
import client from '../server/server'
import Loader from '../components/Loader'
import ReportViewsList from '../ReportDownload/ReportViewsList.vue'
export default {
  name: 'ReportItem',
  components: {
    Loader, ReportViewsList
  },
  data () {
    return {
      list: [],
      pages: {
        now: 1,
        sum: 1
      },
      total: '',
      loading: false
    }
  },
  created () {
    let keyword = this.$route.params.keyword
    // console.log(keyword)
    if (keyword) {
      this.search()
    }
  },
  watch: {
    '$route.params' (val) {
      // console.log(val)
      this.pages.now = 1
      this.search()
    }
  },
  methods: {
    search () {
      let params = {
        keyword: this.$route.params.keyword,
        page: this.pages.now,
        size: 6
      }
      if (params.page === 1) {
        this.list = []
      }
      this.loading = true
      client.getSearchReports(params)
        .then(res => {
          if (res.success) {
            this.total = res.data.total
            this.pages.sum = res.data.pages
            let tmp = res.data.list.map(d => {
              return Object.assign({}, d, {
                brands: [d.priBrand].concat(d.secBrands)
              })
            })
            if (this.pages.now === 1) {
              this.list = [...tmp]
            } else {
              this.list = this.list.concat(tmp)
            }
            this.loading = false
          }
        })
    },
    more () {
      this.pages.now++
      this.search()
    },
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeReportCollect(data)
        .then(res => {
          if (res.success) {
            this.list.find(d => d.id === id).hasCollect = boolean
          } else {
            return new Error(res.message)
          }
        })
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/report_default.png')
    },
    buyReport () {
      const qrcodeUrl = require('@index/assets/img/index/qrcode.png')
      let html = `
        <div style="text-align: center">
            <img src=${qrcodeUrl} style="width: 200px;height: 200px">
            <p>请联系客服购买报告</p>
        </div>
      `
      this.$alert(html, '', {
        dangerouslyUseHTMLString: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/common";
.report-item {
  background: #fff;
  border-radius: 4px;
  height: calc(100% - 72px);
  .component-title {
    font-size: 16px;
    color: #333;
    margin: 30px 0 20px;
    span {
      color: #f87653;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/ReportItem.vue